<template>
    <div id="app">
        <view-header></view-header>
        <div class="page-wrapper" id="page-wrapper">
            <transition name="fade">
                <router-view></router-view>
            </transition>
        </div>
        <view-footer></view-footer>
    </div>
</template>

<script>
    import ViewHeader from './components/nav/Header'
    import ViewFooter from './components/nav/Footer'

    export default {
        name: 'app',
        components: {
            ViewHeader, ViewFooter
        },
        mounted: function () {
//            $('#loading').fadeOut();
//            $('body').css('overflow', 'auto');
//            let that = this;
//            this.myCard = '';
//            this.$http.get('recharge/mycard/payMethod').then(
//                function (response) {
//                  that.myCard = JSON.parse(response.data).message.methods;
//                });
        }
    }
</script>

<style lang="scss" rel="stylesheet/scss">
    @import "assets/scss/style.scss";

    * {
        margin: 0;
        padding: 0;
        box-sizing: border-box;
    }

    html {
        height: 100%;
        background: #f1f1f1;
    }

    body {
        //max-width: 2000px;
        min-width: 1230px;
        margin: 0 auto;
        font-family: Arial, Helvetica, "Microsoft YaHei", sans-serif, 宋体;
        background: #f1f1f1;
        height: 100%;
        @include no-select;
    }

    #app, body, html {
        height: 100%;
        width: 100%;
    }

    .page-wrapper {
        background: #f1f1f1;
        padding-top: 70px;
        width: 100%;
        min-height: calc(100vh - 180px);
    }

    .el-loading-mask {
        //background-color: rgba(255, 255, 255, 0.8) !important;
        .el-loading-spinner .path {
            stroke: $orange-color;
            stroke-width: 6
        }
    }
</style>



// WEBPACK FOOTER //
// App.vue?424574ab